import { render, staticRenderFns } from "./PermissionPreviewDrawer.vue?vue&type=template&id=5f97de4e"
import script from "./PermissionPreviewDrawer.vue?vue&type=script&lang=js"
export * from "./PermissionPreviewDrawer.vue?vue&type=script&lang=js"
import style0 from "./PermissionPreviewDrawer.vue?vue&type=style&index=0&id=5f97de4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports